import { render, staticRenderFns } from "./PersonalityDpdBelux.vue?vue&type=template&id=4a988e68&scoped=true&"
import script from "./PersonalityDpdBelux.vue?vue&type=script&lang=js&"
export * from "./PersonalityDpdBelux.vue?vue&type=script&lang=js&"
import style0 from "./PersonalityDpdBelux.vue?vue&type=style&index=0&id=4a988e68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a988e68",
  null
  
)

export default component.exports